import pickBy from "lodash.pickby";

import * as types from "./types";

type ReducerArgs = {
  type: string;
  payload: object;
};

const initialState = {
  uuid: null,
  status: null,
  invocations: {},
  paymentDetails: null,
  publisher: {},
  isProcessingPayment: false,
};

export default function (state = initialState, { type, payload }: ReducerArgs): object {
  switch (type) {
    case types.SET_TOKEN:
      return { ...state, uuid: payload };
    case types.SET_STATUS:
      return { ...state, status: payload };
    case types.SET_INVOCATIONS:
      return { ...state, invocations: { ...state.invocations, ...payload } };
    case types.DELETE_INVOCATIONS:
      const invocations = payload as Array<string>;
      const filteredInvocations = pickBy(
        state.invocations,
        (_: any, key: string) => !invocations.includes(key),
      );
      return { ...state, invocations: filteredInvocations };
    case types.SET_PAYMENT_DETAILS:
      return { ...state, paymentDetails: payload };
    case types.SET_PUBLISHER:
      return { ...state, publisher: { ...state.publisher, ...payload } };
    case types.IS_PROCESSING_PAYMENT:
      return { ...state, isProcessingPayment: payload };
    default:
      return state;
  }
}
